import { AsyncState, Updater, errorAsyncState, loadingAsyncState } from "widgets-for-react";
import { GetCoursePageByCourseId, GetEventTemplate, getData } from "../../utils/api";
import { BreadcrumbProps } from "../sharedLayout/breadcrumbs";
import { SubmissionMessage } from "./educationFormUtils";
import { EventTemplate } from "../models/Events/Events";
import { CoursePage } from "../cmsPage/cmsPageState";
import { getCourseBreadcrumb } from "../cmsPage/pages/course-details";
import { CoursePageData } from "../cmsPage/sharepointPageApi/types/pageData";
import { transformCourseDetailsPageData } from "../cmsPage/sharepointPageApi/transformers/pageDataToPage";

export interface EducationFormState {
  eventData: AsyncState<EventTemplate>
  pageData: AsyncState<CoursePage>
  submissionData?: SubmissionMessage
}

export const initialEducationFormState = (eventId: string | null): EducationFormState => ({
  eventData: eventId ? loadingAsyncState(() => getData<EventTemplate>(GetEventTemplate(eventId))) : errorAsyncState(404),
  pageData: eventId ? loadingAsyncState(() => getData<CoursePage, CoursePageData>(GetCoursePageByCourseId(eventId), transformCourseDetailsPageData)) : errorAsyncState(404),
  submissionData: undefined
})

export const EducationFormStateUpdaters = {
  updatePageData: (u: Updater<AsyncState<CoursePage>>): Updater<EducationFormState> => s0 => ({ ...s0, pageData: u(s0.pageData) }),
  updateEventData: (u: Updater<AsyncState<EventTemplate>>): Updater<EducationFormState> => s0 => ({ ...s0, eventData: u(s0.eventData) }),
}

export const getBreadcrumbsCourseForm = (pageData: CoursePage): BreadcrumbProps => {
  const breadcrumbs = getCourseBreadcrumb(pageData)
  breadcrumbs.push({ title: "Inschrijven", url: "" })
  return { links: breadcrumbs }
}

